<template>
  <section class="container" :class="!isMeeting ? 'boxWithBorder' : ''">
    <SmallItinerarySidebar
      v-if="bookTrip.currentlyBooking"
      :sol="solutionAll"
      :key="
        solutionAll.flight.key + solutionAll.hotel.key + solutionAll.car.key
      "
      class="bookingDropdown mr-5"
    />

    <div
      v-if="!isMeeting"
      class="is-flex is-justify-content-center is-align-content-center mb-5"
    >
      <b-icon icon="bed" size="" type="is-primary"> </b-icon>
      <h2 class="gant-text is-bold ml-1">Hotels</h2>
    </div>

    <EditSearchLink
      v-if="showEditSearchLink('hotel')"
      :label="toggleSearchLabel('hotel')"
      @iconClicked="toggleSearchForm('hotel')"
    />

    <!-- FLIGHT DETAILS HEADER -->
    <FlightDetailsHeader />

    <!-- TODO check on Hide/Edit Search Link -->
    <div
      class="hotelForm"
      :class="bookTrip.currentlyBooking ? 'pt-1' : ''"
      v-if="!this.bookTravel.formsCollapsed.hotel"
    >
      <!-- Meeting Info Bar bar -->
      <div v-if="pathMixin_isMeeting" class="box">
        <p class="is-size-5">
          Will you provide your own stay during this meeting?
        </p>
        <!-- <b-button>
          Opt out of flight search steps
        </b-button> -->
        <p class="is-size-6 mb-3">
          If you do not need a hotel booked for this meeting, please click below
          to skip the hotel search steps.
        </p>
        <b-button @click="optOutHotel" type="is-primary">
          No Hotel Required
        </b-button>
      </div>

      <div :class="pathMixin_isMeeting ? 'box' : ''">
        <div
          class="is-flex is-justify-content-space-between mt-3 flexContainer"
        >
          <div class="is-flex-grow-1 flexContainerItem">
            <PlaceSearch
              v-if="!pathMixin_isMeeting"
              v-model="location"
              @locUpdate="setLocation"
              class="mr-1"
              data-test="location_input"
            />
            <b-field v-else>
              <b-input
                placeholder="Disabled"
                :value="meetingInfo.meeting.meetingLocation"
                disabled
              ></b-input>
            </b-field>
          </div>
          <div class="is-flex-grow-1 flexContainerItem">
            <DateSelectorRange
              v-if="!pathMixin_isMeeting"
              segmentType="hotel"
              class="mr-1"
              v-model="hotelDates"
              data-test="date_range_selector"
            />
            <DatePickerSearchRangeMeetings
              v-if="pathMixin_isMeeting"
              @input="setMeetingsDates"
              segmentType="hotel"
              :minDate="meetingInfo.meeting.earliestArrival.date"
              :maxDate="meetingInfo.meeting.latestDeparture.date"
            />
          </div>
          <div class="is-flex-grow-0 flexContainerItem is-hidden-mobile">
            <b-button
              @click="checkInputs"
              expanded
              class="button is-primary ubuntu"
              data-test="submit_search"
            >
              Search Hotels
            </b-button>
          </div>
        </div>
        <b-collapse
          :open="false"
          @open="toggleAdvancedSearch(true)"
          @close="toggleAdvancedSearch(false)"
          aria-id="contentIdForA11y1"
          class="mt-3"
        >
          <AdvancedSearchOptionsLink slot="trigger" />
          <div class="notification" :style="advancedScroll">
            <div class="content">
              <div class="field">
                <b-checkbox type="is-primary" v-model="usedAdvanced">
                  Use Advanced Settings
                </b-checkbox>
              </div>
              <h3 v-if="!modal">
                Extra Preferences
              </h3>
              <div :class="modalColumns">
                <div :class="modalColumn">
                  <b-field label="Radius Range by Miles">
                    <b-numberinput
                      v-model="radius"
                      min="0"
                      size="is-small"
                      controls-alignment="right"
                      controls-position="compact"
                    ></b-numberinput>
                  </b-field>
                </div>
                <div :class="modalColumn">
                  <b-field label="Star Rating">
                    <b-select v-model="starRating" placeholder="Select Rating">
                      <option
                        v-for="option in starRatings"
                        :value="option"
                        :key="option"
                      >
                        {{ option }}
                      </option>
                    </b-select>
                  </b-field>
                </div>
                <div :class="modalColumn">
                  <b-field label="Search by Hotel Chain">
                    <TagAutocomplete
                      placeholder="e.g. Hilton"
                      icon="magnify"
                      :chainData="chainData"
                      :selected="chain"
                      @list="
                        (option) => {
                          chain = option;
                        }
                      "
                    >
                    </TagAutocomplete>
                  </b-field>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
        <div class="mt-2 is-hidden-tablet">
          <b-button
            @click="checkInputs"
            expanded
            class="button is-primary ubuntu"
            data-test="submit_search"
          >
            Search Hotels
          </b-button>
        </div>
      </div>
    </div>

    <HotelResults v-if="showHotelResults" :formData="formData" />
  </section>
</template>

<script>
import DateSelectorRange from "../../DateComponents/DateSelectorRange.vue";
import DatePickerSearchRangeMeetings from "../../DateComponents/DatePickerSearchRangeMeetings";
import PlaceSearch from "../PlaceSearch.vue";
import TagAutocomplete from "../../Tags/TagAutocomplete.vue";
import TravellerModal from "../../Traveller/TravellerModal.vue";
import AdvancedSearchOptionsLink from "../../UI/AdvancedSearchOptionsLink";
import HotelResults from "./HotelResults";
import bookingMixin from "../../../mixins/bookingMixin";
import meetingsMixin from "../../../mixins/meetingsMixin";
import EditSearchLink from "../EditSearchLink";
import SmallItinerarySidebar from "../../Itinerary/SmallItinerarySidebar";
import FlightDetailsHeader from "@/components/BookTravel/FlightDetailsHeader.vue";

export default {
  name: "HotelForm",
  mixins: [bookingMixin, meetingsMixin],
  components: {
    DateSelectorRange,
    DatePickerSearchRangeMeetings,
    PlaceSearch,
    TagAutocomplete,
    AdvancedSearchOptionsLink,
    HotelResults,
    EditSearchLink,
    SmallItinerarySidebar,
    FlightDetailsHeader
  },
  props: {
    modal: Boolean,
  },
  data: function() {
    return {
      meetingDates: null,
      starRatings: ["5", "4", "3", "2", "1", "No Preference"],
      showHotelResults: false,

      formData: {},
      //FORM DATA
      checkinDate: null,
      checkoutDate: null,
      location: "",

      //ADVANCED FORM SETTINGS
      usedAdvanced: false,
      radius: 5,
      starRating: "No Preference",
      chain: [],
    };
  },
  computed: {
    chainData() {
      return Object.entries(this.$store.state.bookTravel.vendors.hotelChains);
    },
    advancedScroll() {
      if (this.modal) {
        return "overflow:scroll; height:180px;";
      } else {
        return "";
      }
    },
    /*
    hotelDetailsAlt() {
      return this.$store.getters["bookTravel/getHotelDet"]; // TODO check dates
    },
    */
    hotelDates: {
      //return this.$store.getters['bookTravel/getHotelDates']; // TODO check dates
      get() {
        if (this.checkinDate && this.checkoutDate) {
          return Array(this.checkinDate, this.checkoutDate);
        } else {
          return [];
        }
      },
      set(dates) {
        this.checkinDate = dates[0];
        this.checkoutDate = dates[1];
      },
    },
    errorMessages() {
      let messages = [];

      let firstTravelDate = this.$date.getFirstTravelDate();
      //var yesterday = new Date()
      //yesterday.setDate(yesterday.getDate() - 1)
      if (this.pathMixin_isMeeting) {
        if (!this.meetingDates) {
          messages.push("Please select a valid check-in date");
          messages.push("Please select a valid check-out date");
        } else {
          if (
            this.meetingDates[0] <
            new Date(this.meetingInfo.meeting.earliestArrival.date)
          ) {
            messages.push("Please select a valid check-in date");
          }
          if (
            this.meetingDates[1] <
            new Date(this.meetingInfo.meeting.meetingEndDate)
          ) {
            messages.push("Please select a valid check-out date");
          } else if (this.meetingDates[1] <= this.meetingDates[0]) {
            messages.push("Check-out date must be after check-in date");
          }
        }
      } else {
        if (this.checkinDate < firstTravelDate) {
          messages.push("Please select a valid check-in date");
        }
        if (this.checkoutDate < firstTravelDate) {
          messages.push("Please select a valid check-out date");
        } else if (this.hotelDates[1] <= this.hotelDates[0]) {
          messages.push("Check-out date must be after check-in date");
        }
      }

      if (!this.pathMixin_isMeeting && Object.keys(this.location).length < 1) {
        messages.push("Please enter a valid location");
      }

      return messages;
    },
    modalColumns() {
      if (this.modal) {
        return "card-content";
      } else {
        return "columns";
      }
    },
    modalColumn() {
      if (this.modal) {
        return "content";
      } else {
        return "column";
      }
    },
  },
  methods: {
    setMeetingsDates(val) {
      this.meetingDates = val;
      this.updateDates(this.meetingDates);
    },
    checkInputs() {
      if (this.errorMessages.length > 0) {
        this.launchInputErrorDialog(this.errorMessages);
      } else {
        this.search();
      }
    },
    search() {
      if (this.$store.state.travellersAndTrips.travellers.set) {
        this.sendSearch();
      } else {
        this.cardModal();
      }
    },

    sendSearch() {
      this.switchMapView("hotel", false); // TODO test
      this.showHotelResults = true;

      //setting or updating the values of the formData object here triggers the formData watcher in HotelResults.vue,
      //which then calls the HotelResults getData() method to submit the search to HuddleLabs API
      this.formData = {
        loc: this.location,
        checkinDate: this.checkinDate,
        checkoutDate: this.checkoutDate,
        advancedSettings: {
          active: this.usedAdvanced,
          chain: this.chain,
          radius: this.radius,
          starRating: this.starRating,
        },
      };
    },
    updateDates(range) {
      this.checkinDate = range[0];
      this.checkoutDate = range[1];
    },
    toggleAdvancedSearch(val) {
      this.usedAdvanced = val;
    },
    setLocation(value) {
      //this.$store.commit("bookTravel/ALTER_H_LOC", value);
      this.location = value;
    },
    /*
    setHotelAdvanced() {
      var settings = this.hotelDetailsAlt.advancedSettings;
      settings.active = this.usedAdvanced;
      this.$store.commit("bookTravel/ALTER_H_ADVANCED", settings);
    },
    */
    setDefaultFormValues() {
      //Use booked flight details to set default form values
      if (this.flightArrivalMoment.isValid()) {
        this.checkinDate = this.flightArrivalDate;
      }

      if (this.flightDepartureMoment.isValid()) {
        this.checkoutDate = this.flightDepartureDate;
      }

      if (this.flightArrivalLeg?.arrivingAirport) {
        this.location = this.$helpers.findAirportByCode(
          this.flightArrivalLeg.arrivingAirport
        );
      }
    },
    cardModal(closable = true) {
      var details = {
        parent: this,
        component: TravellerModal,
        props: {
          profiler: this.$globals.profile,
          closable: closable,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
      };
      this.$buefy.modal.open(details);
    },
  },
  mounted() {
    this.setDefaultFormValues();

    if (this.pathMixin_isMeeting) {
      let meetingLocation = {};
      if (this.meetingInfo.meeting.meetingLocation) {
        // console.log('meeting loc', this.meetingInfo.meeting.meetingLocationCoordinates);
        meetingLocation.lat = this.meetingInfo.meeting.meetingLocationCoordinates.latitude;
        meetingLocation.lng = this.meetingInfo.meeting.meetingLocationCoordinates.longitude;
      }
      //this.setValue1(meetingLocation);
    }
  },
};
</script>

<style lang="scss" scoped></style>
